// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"user-plan_Wrapper__3cV5n","Text":"user-plan_Text__jNyx7","Link":"user-plan_Link__UJppJ","Date":"user-plan_Date__C_reo","DaysLeft":"user-plan_DaysLeft__jCXFs"};